import { openDB, deleteDB } from 'idb';
import { FILESCACHE_KEYS, CACHE_STORE_KEYS } from '../enums/files-cache.enum';
import { FileServiceResponse } from '../interfaces/files-cache.interface';
import Moment from 'moment';

export class IndexDBService {

  private handle: any = null;

  constructor() {
    this.openDB();
  }

  async openDB(): Promise<boolean> {
    try {
      this.handle = await openDB(FILESCACHE_KEYS.STORE_NAME, 2, {//Change version number where you add a new store
        upgrade(db, oldVersion, newVersion) {
          CACHE_STORE_KEYS.forEach(store => {
            if (!db.objectStoreNames.contains(store)) {
              db.createObjectStore(store);
            }
          });
        },
      });
      await this.validateExpiratedDataEduacStore();
      return true;
    } catch(err) {
      return false;
    }
  }

  async closeDB(name) {
    await deleteDB(name, {});
  }

  private async validateExpiratedDataEduacStore() {
    let cursor = await this.handle.transaction(FILESCACHE_KEYS.STORE_EXP).store.openCursor();
    while (cursor) {
      const creationDate = this.getCreationDate(cursor.value);
      const isNewVersion = this.getHasToCleanFilesNewVersion(creationDate);
      const now = new Date();
      if(Moment(now).isAfter(cursor.value) || isNewVersion) {
        this.removeFile(cursor.key);
      } 
      cursor = await cursor.continue();
    }
  }
  
  private getCreationDate(date: Date) {
    const dateToConvert = new Date(date);
    return Moment(dateToConvert.setDate(dateToConvert.getDate() - FILESCACHE_KEYS.STORE_EXP_TIME)).format('YYYY-MM-DD');
  }

  private getDateToExp(): Date {
    var date = new Date();
    date.setDate(date.getDate() + FILESCACHE_KEYS.STORE_EXP_TIME);
    return date;
  }

  async getFile(key, store: string = FILESCACHE_KEYS.STORE_VAL): Promise<FileServiceResponse> {
    try {
      const file = await this.handle.get(store, key);
      return { result: true, file };
    } catch(error) {
      return { result: false, error };
    }
  }

  async saveFile(key, data, store: string = FILESCACHE_KEYS.STORE_VAL): Promise<FileServiceResponse> {
    try {
      const expTime = this.getDateToExp();
      await this.saveValue(key, data, store);
      await this.saveValue(key, expTime, FILESCACHE_KEYS.STORE_EXP);
      return { result: true };
    } catch(error) {
      return { result: true,  error };
    }
  }

  async getValue(key: string, store: string = FILESCACHE_KEYS.STORE_VAL) {
    return this.handle.get(store, key);
  }

  async saveValue(key: string, val: any, store: string = FILESCACHE_KEYS.STORE_VAL) {
    return this.handle.put(store, val, key);
  }

  async saveExpirableValue(key: string, val: any, expirationDate: Date, store: string = FILESCACHE_KEYS.STORE_VAL) {
    await this.saveValue(key, val, store);
    await this.saveValue(key, expirationDate, FILESCACHE_KEYS.STORE_EXP);
  }

  async deleteValue(key: string, store: string = FILESCACHE_KEYS.STORE_VAL) {
    await this.handle.delete(store, key);
    await this.handle.delete(FILESCACHE_KEYS.STORE_EXP, key);
  }

  async removeFile(key) {
    await this.deleteValue(key);
  }

  async getAllkeys(store) {
    return this.handle.getAllKeys(store);
  }

  async getValuesByPrefix(storeName: string, prefix: string): Promise<FileServiceResponse[]> {
    const transaction = this.handle.transaction(storeName, 'readonly');
    const store = transaction.objectStore(storeName);
    const range = IDBKeyRange.bound(prefix, `${prefix}\uffff`, false, false);
    let cursor = await store.openCursor(range);
    const results: any[] = [];
    
    while (cursor) {
      results.push(cursor.value);
      cursor = await cursor.continue();
    }

    return results;
  }

  async clearAllStore(storeName: string): Promise<void> {
    const transaction = this.handle.transaction(storeName, 'readwrite');
    const store = transaction.objectStore(storeName);
    await store.clear();
  }
  

  getHasToCleanFilesNewVersion(date: string) {
    const versionDate = Moment('2021-12-13');
    return Moment(date).isBefore(versionDate);
  }

}